"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewSurveyResultsAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const commands_1 = require("../commands");
function ViewSurveyResultsAction(surveyId, title) {
    // NOTE: if this text is changed, make sure to change the text in Polly preview as well.
    const viewAllResultsButtonLabel = "View all results";
    return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: title || viewAllResultsButtonLabel,
        data: (0, commands_1.SurveyResultsViewCommand)(surveyId).toTaskFetchCommand(),
    });
}
exports.ViewSurveyResultsAction = ViewSurveyResultsAction;
//# sourceMappingURL=ViewSurveyResultsAction.js.map